import { GLHF } from '../../../../../constants';
import { FlexLayout } from '../../../../../components';
import { Format } from '../../../../../utils/string';
import { Install } from '../Install';
import { MainModel } from '../models/Main.model';

/**
 * 화면 > 상단 그리드 레이아웃
 * @window w_tb_e601w_sulchi_08
 * @category 설치수주매출통계
 */
export const InstallGridHeader: GLHF<MainModel, Install> = (scope) => ([
  {
    id: 'spjangnm',
    text: '사업장명',
    width: 8,
    trail: () => (
      <FlexLayout
        justify="center"
        align="center"
      >
        합 계
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.spjangnm}
      </FlexLayout>
    ),
  },
  {
    id: 'contamt',
    text: '수주금액',
    width: 7,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {scope.state.contamt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {Format.number(x.contamt)}
      </FlexLayout>
    ),
  },
  {
    id: 'contamt14',
    text: '수주(설치)',
    width: 7,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {scope.state.contamt14_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {Format.number(x.contamt14)}
      </FlexLayout>
    ),
  },
  {
    id: 'contamt15',
    text: '수주(리모델링)',
    width: 7,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {scope.state.contamt15_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {Format.number(x.contamt15)}
      </FlexLayout>
    ),
  },
  {
    id: 'notmisamt',
    text: '미매출',
    width: 7,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {scope.state.notmisamt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {Format.number(x.notmisamt)}
      </FlexLayout>
    ),
  },
  {
    id: 'misamt',
    text: '설치매출',
    width: 7,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {scope.state.misamt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {Format.number(x.misamt)}
      </FlexLayout>
    ),
  },
  {
    id: 'rcvamt',
    text: '설치입금',
    width: 7,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-blue)' }}
      >
        {scope.state.rcvamt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-blue)' }}
      >
        {Format.number(x.rcvamt)}
      </FlexLayout>
    ),
  },
  {
    id: 'iamt',
    text: '설치미수금',
    width: 7,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {scope.state.iamt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {Format.number(x.iamt)}
      </FlexLayout>
    ),
  },
  {
    id: 'jamt',
    text: (
      <FlexLayout isVertical={true}>
        <FlexLayout>
          잔액
        </FlexLayout>

        <FlexLayout>
          (수주-입금)
        </FlexLayout>
      </FlexLayout>
    ),
    width: 7,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {scope.state.jamt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {Format.number(x.jamt)}
      </FlexLayout>
    ),
  },
  {
    id: 'qty',
    text: '대수',
    width: 5,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {scope.state.qty_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {Format.number(x.qty)}
      </FlexLayout>
    ),
  },
  {
    id: 'qty14',
    text: (
      <FlexLayout isVertical={true}>
        <FlexLayout>
          대수
        </FlexLayout>

        <FlexLayout>
          (설치)
        </FlexLayout>
      </FlexLayout>
    ),
    width: 5,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {scope.state.qty14_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {Format.number(x.qty14)}
      </FlexLayout>
    ),
  },
  {
    id: 'qty15',
    text: (
      <FlexLayout isVertical={true}>
        <FlexLayout>
          대수
        </FlexLayout>

        <FlexLayout>
          리모델링
        </FlexLayout>
      </FlexLayout>
    ),
    width: 5,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {scope.state.qty15_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {Format.number(x.qty15)}
      </FlexLayout>
    ),
  },
  {
    id: 'misamt2',
    text: '매출',
    width: 7,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {scope.state.misamt2_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {Format.number(x.misamt2)}
      </FlexLayout>
    ),
  },
  {
    id: 'rcvamt2',
    text: '입금',
    width: 7,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-blue)' }}
      >
        {scope.state.rcvamt2_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-blue)' }}
      >
        {Format.number(x.rcvamt2)}
      </FlexLayout>
    ),
  },
  {
    id: 'iamt2',
    text: '미수금',
    width: 7,
    trail: () => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {scope.state.iamt2_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {Format.number(x.iamt2)}
      </FlexLayout>
    ),
  },
]);
